import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export default entityType => {
  const selectAllEntities = useCallback(state => state.entities[entityType], [entityType]);
  return useSelector(selectAllEntities);
};
